import React from "react"
import ReactGA from "react-ga"
import { connect } from "react-redux"
import Root from "components/views/Root"
import { getIsLoggedIn } from "reducers/application"
import { fetchReduxData } from "actions/loginActions"
import { ScrollToTop } from "../views/ScrollToTop"

class RootContainer extends React.Component {
  constructor(props) {
    super(props)

    ReactGA.initialize("UA-88373804-1", {
      cookieDomain: "none"
    })
  }

  componentDidMount() {
    this.props.fetchReduxData()
  }

  render() {
    const fullPath = window.location.pathname + window.location.search
    ReactGA.set({ page: fullPath })
    ReactGA.pageview(fullPath)
    return (
      <ScrollToTop>
        <Root loggedIn={this.props.isLoggedIn} />
      </ScrollToTop>
    )
  }
}

const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state)
})

RootContainer = connect(mapStateToProps, {
  fetchReduxData
})(RootContainer)

export default RootContainer
